/* =========================================================
   GGS scroll reveal. Loaded once, by GGS Header, because that is the only
   section on every template. Markup-free: it finds its own targets.

   THE BUG THIS FILE WAS REWRITTEN TO FIX (2026-09-11). Aubrey: "the blog page
   is empty." It was. Every element in the Publications header and the featured
   article sat at opacity:0 and never came back.

   The cause: this script used the `data-ggs-r` attribute as BOTH the thing that
   hides an element (ggs-motion.css) and its own "I have already handled this
   one" marker. sections/ggs-blog.liquid writes `data-ggs-r` into its own markup
   to opt its rows into the effect — a perfectly reasonable thing to do — and the
   old collector skipped any element that already had the attribute. So those
   elements were hidden by the CSS, never collected into a group, and therefore
   never given `.is-in`. Permanently invisible, with no error anywhere.

   The fix is two lines: the collector now MATCHES `[data-ggs-r]` as well as the
   class list, so hand-marked elements are adopted into their section's group,
   and "already handled" is tracked on a JS property instead of the attribute.

   If you add `data-ggs-r` to markup in a section, it will now animate with the
   rest of that section. If this script does not run at all, nothing is hidden —
   the html.ggs-motion class it adds is what arms the CSS — so failure is safe.
   ========================================================= */
(function () {
  "use strict";

  if (!("IntersectionObserver" in window)) return;
  if (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

  var SEL = [
    ".ggs__eye", ".ggs__d1", ".ggs__d2", ".ggs__d3", ".ggs__d4", ".ggs__lede",
    ".ggs__hero-cta", ".ggs__fine", ".ggs__tbtn", ".ggs__cards > li",
    ".ggs__highlight-copy > *", ".ggs__mech-statlabel", ".ggs__mech-stat",
    ".ggs__claim", ".ggs__part", ".ggs__part-note", ".ggs__tablewrap",
    ".ggs__ticker", ".ggs__chips", ".ggs__meta", ".ggs__safety > *",
    ".ggs__faq details", ".ggs__bookend-body > *", ".ggs__bookend-close > *",
    ".ggs__band-cap",
    "[data-ggs-r]"
  ].join(",");

  var STEP = 70;
  var CAP = 420;

  var groups = [];
  var roots = document.querySelectorAll(".ggs");

  for (var i = 0; i < roots.length; i++) {
    var root = roots[i];
    if (root.classList.contains("ggs-hdr") || root.classList.contains("ggs-hdr__spacer")) continue;

    var found = root.querySelectorAll(SEL);
    if (!found.length) continue;

    var targets = [];
    for (var j = 0; j < found.length; j++) {
      var el = found[j];
      if (el.closest(".ggs-hdr")) continue;
      if (el.__ggsClaimed) continue;
      el.__ggsClaimed = true;
      el.setAttribute("data-ggs-r", "");
      el.style.setProperty("--ggs-d", Math.min(targets.length * STEP, CAP) + "ms");
      targets.push(el);
    }
    if (targets.length) groups.push({ root: root, targets: targets, done: false });
  }

  if (!groups.length) return;

  document.documentElement.classList.add("ggs-motion");

  var revealedAny = false;

  function reveal(g) {
    if (g.done) return;
    g.done = true;
    revealedAny = true;
    for (var m = 0; m < g.targets.length; m++) g.targets[m].classList.add("is-in");
  }

  function revealEverything() {
    for (var q = 0; q < groups.length; q++) reveal(groups[q]);
    /* Anything still carrying the attribute belongs to no group at all — it
       cannot animate, so it must at least be visible. */
    var left = document.querySelectorAll("[data-ggs-r]:not(.is-in)");
    for (var s = 0; s < left.length; s++) left[s].classList.add("is-in");
  }

  var io;
  try {
    io = new IntersectionObserver(function (entries) {
      for (var k = 0; k < entries.length; k++) {
        if (!entries[k].isIntersecting) continue;
        io.unobserve(entries[k].target);
        if (entries[k].target.__ggsGroup) reveal(entries[k].target.__ggsGroup);
      }
    }, { threshold: 0.08, rootMargin: "0px 0px -6% 0px" });

    for (var n = 0; n < groups.length; n++) {
      groups[n].root.__ggsGroup = groups[n];
      io.observe(groups[n].root);
    }
  } catch (err) {
    /* Never leave the page hidden because the observer would not build. */
    revealEverything();
    return;
  }

  /* A tall section can never reach the 8% threshold, so the observer alone is
     not enough — sweep anything whose root is in view. */
  function sweep() {
    var vh = window.innerHeight || document.documentElement.clientHeight || 0;
    for (var p = 0; p < groups.length; p++) {
      if (groups[p].done) continue;
      var r = groups[p].root.getBoundingClientRect();
      if (r.top < vh && r.bottom > 0) {
        io.unobserve(groups[p].root);
        reveal(groups[p]);
      }
    }
  }

  sweep();
  requestAnimationFrame(sweep);
  /* Images settling can move a section into view after first paint. */
  window.addEventListener("load", sweep);

  var ticking = false;
  window.addEventListener("scroll", function () {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () { ticking = false; sweep(); });
  }, { passive: true });

  /* Last resort. Kept conditional on nothing at all having revealed, so a page
     that is working normally still animates its lower sections on scroll. */
  setTimeout(function () { if (!revealedAny) revealEverything(); }, 3000);
}());
